import React, { useState, useEffect } from "react";
import { getContainerClassPerMaxWidth, getClassConditionalAppend } from "../../utils";
import { Container, ContainerFW } from "../global";
const RatioContainer = ({ leftContent, rightContent, ratio, changeToColumn, containerMaxWidth }) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const containerMaxWidthClass = getContainerClassPerMaxWidth(containerMaxWidth);
    const containerExtraClass = getClassConditionalAppend(containerMaxWidthClass);
    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    const [leftRatio, rightRatio] = ratio.split(":").map(Number);
    const total = leftRatio + rightRatio;
    const getFlexValues = () => {
        const leftFlex = (leftRatio / total) * 100;
        const rightFlex = (rightRatio / total) * 100;
        return [leftFlex, rightFlex];
    };
    const [leftFlex, rightFlex] = getFlexValues();
    const dropToColumnsClass = windowWidth <= changeToColumn ? "ratio-container__column" : "";
    return (React.createElement(ContainerFW, { className: containerExtraClass },
        React.createElement(Container, { className: containerExtraClass },
            React.createElement("div", { className: `ratio-container ${dropToColumnsClass}` },
                React.createElement("div", { className: "ratio-container__left", style: { flex: `${leftFlex}%` } }, leftContent),
                React.createElement("div", { className: "ratio-container__right", style: { flex: `${rightFlex}%` } }, rightContent)))));
};
export default RatioContainer;
